<template>
  <div>
    <b-modal v-model="isComponentAjoutLieuDeLivraison"
        has-modal-card
        width="600px"
        class="modal">
      <creation-lieu-de-livraison
        :nomLieuDeLivraison="nomLieuDeLivraison"
        @select="selectLieuDeLivraison"/>
    </b-modal>
    <b-field :label="$t('addEditOrdreTravailTech.lieuDeLivraison.title')">
      <b-autocomplete icon="magnify" v-model="nomLieuDeLivraison"
          :placeholder="
          $t('addEditOrdreTravailTech.lieuDeLivraison.search')"
          field="libelleAutocomplete"
          dropdown-position="bottom"
          :data="listeLieuDeLivraison"
          :loading="isFetching"
          :open-on-focus="true"
          @input="getLieuDeLivraison"
          @select="item => selectLieuDeLivraison(item)">
        <template #header>
          <a @click="checkPermissions(permOtTech.maj)
          ? isComponentAjoutLieuDeLivraison = true : showPopup()"
            class="lien" :class="{ 'text-access-no-permission' :
                  !checkPermissions(permOtTech.maj)}">
            <span>{{$t('addEditOrdreTravailTech.lieuDeLivraison.new')}}</span>
          </a>
          </template>
          <template #empty>
          <div v-if="!isFetching">
              {{$t('addEditOrdreTravailTech.lieuDeLivraison.noResult')}}
          </div>
          <div v-else>
              {{$t('addEditOrdreTravailTech.lieuDeLivraison.autocomplete.search')}}
          </div>
        </template>
      </b-autocomplete>
    </b-field>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import debounce from 'lodash/debounce';
import adressFullStringGetter from '@/services/general/adressFullStringGetter';
import messageErreur from '@/services/general/messageErreur';
import { ORDRE_TRAVAIL } from '@/configuration/logistique/permissionsLogistiqueConf';
import { TIERS_SOUS_TYPE_LIEU_DE_LIVRAISON } from '@/configuration/tiers/tiersConf';
import { getAll } from '@/api/tiers/index';
import creationLieuDeLivraison from './p_creationLieuDeLivraison';

const Permissions = createNamespacedHelpers('permissions');
const Societe = createNamespacedHelpers('societe');

export default {
  props: {
    lieuDeLivraison: {
      type: Object,
    },
    value: {
      type: String,
    },
  },
  data() {
    return {
      isComponentAjoutLieuDeLivraison: false,
      isFetching: false,
      permOtTech: ORDRE_TRAVAIL,
      listeLieuDeLivraison: [],
    };
  },
  components: {
    creationLieuDeLivraison,
  },
  computed: {
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
    nomLieuDeLivraison: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
  methods: {
    ...Permissions.mapActions({
      showPopup: 'showPopup',
    }),
    getNomCommercialAvecAdresse(lieu) {
      let libelle = lieu?.nomCommercial;
      if (lieu?.adresse) {
        libelle += ` - ${adressFullStringGetter(lieu.adresse, !lieu.adresse.ville)}`;
      } else if (lieu?.adressePostale) {
        libelle += ` - ${adressFullStringGetter(lieu.adressePostale, !lieu.adressePostale.ville)}`;
      }
      return libelle;
    },
    getLieuDeLivraison: debounce(async function loadData() {
      this.isFetching = true;
      try {
        const parameter = {
          query: {
            auto: this.nomLieuDeLivraison,
            societeId: this.societeActiveId,
            sousType: [TIERS_SOUS_TYPE_LIEU_DE_LIVRAISON],
          },
        };
        this.listeLieuDeLivraison = (await getAll(parameter)).data.result.items;
        this.listeLieuDeLivraison.forEach(lieu => {
          lieu.libelleAutocomplete = this.getNomCommercialAvecAdresse(lieu);
        });
        this.isFetching = false;
      } catch (e) {
        messageErreur(this.$i18n);
        this.isFetching = false;
        throw (e);
      }
    }, 500),
    selectLieuDeLivraison(lieu) {
      if (!lieu) return;
      this.nomLieuDeLivraison = this.getNomCommercialAvecAdresse(lieu);
      this.$emit('select', lieu);
    },
  },
  mounted() {
    this.nomLieuDeLivraison = this.getNomCommercialAvecAdresse(this.lieuDeLivraison);
  },
};
</script>
